
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-sidebar__linklist-button-child');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      console.log("aaaa");
      const targetUl = this.nextElementSibling;

      if (targetUl && targetUl.tagName === 'UL') {
        targetUl.classList.toggle('is-open');
        this.classList.toggle('is-open');

        if (targetUl.classList.contains('is-open')) {
        } else {
        }
      }
    });
  });
});

// カート情報を取得して更新する関数
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElement = document.querySelector('.header__cart-dot-custom');
      if (cartCountElement) {
        cartCountElement.textContent = cart.item_count; // または cart.item_count
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

document.addEventListener('DOMContentLoaded', updateCartCount);

document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".sp_cart_btn, .favoorite_btn");
  const variationCart = document.querySelector(".variation_cart");
  const cartCloseBtn = document.querySelector(".variation_cart_close_btn");
  const closeBtn = document.querySelector(".variation_cart_close_innner_btn");
  const header = document.querySelector(".header__outer-wrapper");
  const body = document.querySelector("body");

    cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.add("active");
        variationCart.classList.remove("fade-out-down");
        cartCloseBtn.classList.add("active");
        cartCloseBtn.classList.remove("fade-out-down");
        header.classList.add("hidden");
        body.classList.add("pop");
      }
    });
  });

  function closeModal() {
    if (variationCart) {
      variationCart.classList.remove("active");
      variationCart.classList.add("fade-out-down");
      cartCloseBtn.classList.remove("active");
      cartCloseBtn.classList.add("fade-out-down");
      header.classList.remove("hidden");
      body.classList.remove("pop");
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  if (cartCloseBtn) {
    cartCloseBtn.addEventListener("click", closeModal);
  }
  /*

  cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.add("active");
        cartCloseBtn.classList.add("active");
        header.classList.add("hidden");
        body.classList.add("pop");
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.remove("active");
        cartCloseBtn.classList.remove("active");
        header.classList.remove("hidden");
        body.classList.remove("pop");
      }
    });
  }

  cartCloseBtn.addEventListener("click", function () {
    if (variationCart) {
      variationCart.classList.remove("active");
      cartCloseBtn.classList.remove("active");
      header.classList.remove("hidden");
      body.classList.remove("pop");
    }
  });

*/

});




document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('.sp_button');
  const fixedBtn = document.querySelector('.sp_cart_btn_fixed');

  let isBelowTarget = false;

  if (!target || !fixedBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isBelowTarget = false;
        fixedBtn.classList.remove('active');
      } else {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > targetPosition) {
          isBelowTarget = true;
          fixedBtn.classList.add('active');
        }
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(target);
});


document.addEventListener("DOMContentLoaded", function () {
  // .variation_cart内の.variant-blockにクリックイベントを追加
  const variationCart = document.querySelector('.variation_cart');
  if (variationCart) {
    const variantBlocks = variationCart.querySelectorAll('.variant-block');
    
    variantBlocks.forEach(block => {
      block.addEventListener('click', function() {
        try {
          // クリックされた要素のdata-color値を取得
          const colorValue = this.getAttribute('data-color');
          
          if (colorValue) {
            // .variant-picker__option要素の存在確認
            const variantPickerOption = document.querySelector('.variant-picker__option');
            
            if (variantPickerOption) {
              // 一致するdata-valueを持つ.thumbnail-swatchを探す
              const matchingSwatch = variantPickerOption.querySelector(
                '.thumbnail-swatch[data-value="' + colorValue + '"]'
              );
              
              if (matchingSwatch) {
                // 現在のスクロール位置を保存
                const currentScrollX = window.scrollX;
                const currentScrollY = window.scrollY;
                
                // 一致する要素を疑似的にクリック
                matchingSwatch.click();
                
                // スクロール位置を元に戻す
                window.scrollTo(currentScrollX, currentScrollY);
              }
            }
          }
        } catch (error) {
          // エラーが発生した場合はコンソールに出力（本番環境では削除可能）
          console.warn('variant-block click handler error:', error);
        }
      });
    });
  }
});


// 商品カードスライダー
document.addEventListener('DOMContentLoaded', function() {

  function initializeSwiper(swiperContainer) {
    if (swiperContainer.swiperInstance) {
      return;
    }

    if (swiperContainer.querySelector('.swiper-slide')) {
      swiperContainer.swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: swiperContainer.querySelector('.button-next'),
          prevEl: swiperContainer.querySelector('.button-prev'),
        },
        autoplay: false,
        nested: true,
        autoHeight: true, // autoHeightを再度有効化
        observer: true, // observerを再度有効化
        observeParents: true, // observeParentsを再度有効化
      });
    }
  }

  function setupSwatchListeners(container) {
    container.querySelectorAll('.product-swatches-options__item--swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function(event) {
        event.preventDefault();

        const clickedSwatch = event.currentTarget;
        const variantImageUrl = clickedSwatch.dataset.variantImageUrl;
        const productCard = clickedSwatch.closest('.product-item');

        if (!productCard || !variantImageUrl) {
          return;
        }

        const swiperContainer = productCard.querySelector('.hover-slider');
        if (swiperContainer) {
          initializeSwiper(swiperContainer);
          const currentSwiper = swiperContainer.swiperInstance;

          if (currentSwiper) {
            const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
            if (activeSlide) {
              const mainImage = activeSlide.querySelector('img');
              if (mainImage) {
                mainImage.src = variantImageUrl;
                mainImage.srcset = variantImageUrl;
              }
            }
          }
        }
      });
    });
  }

  // --- 1. スライダーの初期化（ページ読み込み時） ---
  const sliders = document.querySelectorAll('.hover-slider');
  sliders.forEach(slider => {
    initializeSwiper(slider);
  });

  // --- 2. ページ読み込み時に既存のカラーチップのイベントを設定 ---
  setupSwatchListeners(document);

  // --- 3. 遅延読み込みされる要素のためのMutationObserver ---
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const mutationObserver = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.matches('.recommended-products__content')) {
            setTimeout(function() {
              const sliders = node.querySelectorAll('.hover-slider');
              sliders.forEach(slider => initializeSwiper(slider));
              setupSwatchListeners(node);
            }, 300);
          }
        });
      }
    });
  });

  mutationObserver.observe(targetNode, config);
});